import { Action } from '@ngrx/store';

import { UserLookupFilter } from '../shared/user-lookup-filter.model';

export const USER_LOOKUP_INIT = '[USER LOOKUP] - Initialize';
export const USER_LOOKUP_CLEAR_FILTER = '[USER LOOKUP] [FILTER] - Clear Filter';
export const USER_LOOKUP_SET_FILTER = '[USER LOOKUP] [FILTER] - Set Filter';
export const USER_LOOKUP_SELECT_ROW = '[USER LOOKUP] [GRID] - Select Row';
export const USER_LOOKUP_CLEAR_SELECT_ROW = '[USER LOOKUP] [GRID] - Clear Selected Row';
export const USER_LOOKUP_SET_SHOWING = '[USER LOOKUP] [MENU] - Change Showing Area';
export const USER_LOOKUP_REQUEST_DATA = '[USER LOOKUP] [GRID] - Request Data';
export const USER_DETAIL_LOOKUP_SET_SHOWING = '[USER DETAIL LOOKUP] [MENU] - Change Showing Area';
export const USER_DETAIL_LOOKUP_REQUEST_DATA = '[USER DETAIL LOOKUP] [DATA] - Request Data';

export class UserLookupInit implements Action {
  readonly type = USER_LOOKUP_INIT;
}

export class UserLookupSetFilter implements Action {
  readonly type = USER_LOOKUP_SET_FILTER;
  constructor(public filter: UserLookupFilter) {}
}

export class UserLookupClearFilter implements Action {
  readonly type = USER_LOOKUP_CLEAR_FILTER;
}

export class UserLookupSetShowing implements Action {
  readonly type = USER_LOOKUP_SET_SHOWING;
  constructor(public area: string) {}
}

export class UserLookupSelectRow implements Action {
  readonly type = USER_LOOKUP_SELECT_ROW;
  constructor(public row: any) {}
}

export class UserLookupClearSelectedRow implements Action {
  readonly type = USER_LOOKUP_CLEAR_SELECT_ROW;
}

export class UserLookupRequestData implements Action {
  readonly type = USER_LOOKUP_REQUEST_DATA;
}

export class UserDetailLookupSetShowing implements Action {
  readonly type = USER_DETAIL_LOOKUP_SET_SHOWING;
  constructor(public area: string) {}
}

export class UserDetailLookupRequestData implements Action {
  readonly type = USER_DETAIL_LOOKUP_REQUEST_DATA;
  constructor(public data: any) {}
}

export type AdminActions =
  | UserLookupInit
  | UserLookupSetFilter
  | UserLookupClearFilter
  | UserLookupSetShowing
  | UserLookupSelectRow
  | UserLookupClearSelectedRow
  | UserLookupRequestData
  | UserDetailLookupSetShowing
  | UserDetailLookupRequestData;
